import sa from 'sa-sdk-javascript';
import { isObject } from 'lodash';
/**
 * 神策埋点
 */
let server_url = `https://datasink.paquapp.com/sa?project=${
    process.env.UMI_ENV === 'prod' ? 'production' : 'default'
}`;
console.log('server_url', server_url);

let userInfo = JSON.parse(sessionStorage.getItem('info') || null);

export default {
    startLoad() {
        sa.init({
            name: 'sa',
            server_url: server_url,
            use_client_time: true,
            send_type: 'beacon',
            // 是否允许控制台打印查看埋点数据(建议开启查看)
            show_log: false, // process.env.NODE_ENV === 'development' ? true : false,
            heatmap: {
                //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
                clickmap: 'not_collect',
                //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
                scroll_notice_map: 'not_collect',
            },
        });

        sa.registerPage({
            current_url: location.href,
            referrer: 'css',
        });
    },
    login(id) {
        sa.login(id);
    },
    reportClick(trackName, trackData) {
        if (!userInfo) {
            userInfo = JSON.parse(sessionStorage.getItem('info') || null);
        }
        sa.track(
            trackName,
            isObject(trackData)
                ? {
                      apartment: userInfo?.deptId,
                      userName: userInfo?.name,
                      userId: userInfo?.userId,
                      sessionID: sessionStorage.getItem('uuid'),
                      ...trackData,
                  }
                : trackData,
        );
    },
};
